import { createFileRoute } from "@tanstack/react-router";
import { AdminSystemPage } from "@/features/admin/system";

/** System & health (ALP-85): every dependency, queues, versions and recent failures. */
export const Route = createFileRoute("/admin/system")({
  head: () => ({ meta: [{ title: "System · Admin · Malfak" }] }),
  component: AdminSystemPage,
});
